import React, { useEffect, useState } from "react";
import { camelCaseToWords } from "../../../utils/camelCaseToWord";
import { formatPath } from "../../../utils/formatPath";
import { FlexCenter } from "../../layout/FlexCenter/FlexCenter";
import { PanelLayout } from "../../layout/Panel/Panel";
import { Spacing } from "../../layout/Spacing/Spacing";
import IconComponent from "../../shared/IconComponents/IconComponent";
import { TextCustom } from "../../ui/TextCustom";
import { Title } from "../../ui/Title";
import { IBasicDetails, INodeWithPath, TDisplay } from "../../../interface/interfaces";
import { SpacingCustom } from "../../layout/Spacing/SpacingCustom";
import { TTitleSize } from "../../../types/types";
import { CleanButton } from "../../ui/CleanButton";
import { substringWords } from "../../../utils/substringWords";
import { useDraggable } from "@dnd-kit/core";
import { useAppSelector } from "../../../redux/hooks";
import { rootState } from "../../../redux/store";
import { DashboardBar } from "./DashboardBar";

interface IDashboardCardProps {
    node: IBasicDetails,
    idx?: number,
    showBtn?: boolean,
    showBg?: boolean,
    handleCardClick?: (node: INodeWithPath) => void,
    display?:TDisplay,
    iconSize?:number,
    leftDistance?: number,
    titleSize?: TTitleSize,
    rightDistance?: number,
    isOverlay?: boolean,
    hasOpacityTransition?: boolean,
    hasDragIcon?: boolean,
    }

export const DashboardCard: React.FC<IDashboardCardProps> = ({node, hasOpacityTransition = true, hasDragIcon = false, isOverlay = false, titleSize ="m", leftDistance = 1, iconSize = 2.5, idx = 1, showBg = true, display = 'row',handleCardClick}) => {

    const [outline, setOutline] = useState(false);
    const {isDragging, dragNode } = useAppSelector((state => state.dashboardDragAndDrop));
    const {dashboardNodeType} = useAppSelector((state: rootState)=>state.dashboardNodeType);
    
    
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: node.Id,
        data: node
      });

    
    const style: React.CSSProperties = {
        touchAction: 'none',
        opacity: ((isDragging && dragNode && node.Id === dragNode.Id) && hasOpacityTransition) ? 0 : 1,
        cursor: 'grab',
        transform: transform
            ? `translate(${transform.x}px, ${transform.y}px)`
            : undefined,
        // transition: 'transform .2s',
    };

    const articleContent = 
        <CleanButton isDragging = {isDragging} stretch={!isOverlay} func2={()=>setOutline(true)} func3={()=>setOutline(false)} func={()=>handleCardClick && handleCardClick(node)}>
            <Spacing paddingSpacing={`${isOverlay ? 's' : 'l'}`} marginSpacing="none">
                <section className={`dashboard-item dashboard-item__${display}`}>
                    <div className={`dashboard-item__title dashboard-item__title--${isOverlay ? 'overlay' : 'normal'}`}>
                        <SpacingCustom paddingBottom={1} paddingTop={1} paddingLeft={dashboardNodeType === "inBox" && hasDragIcon ? leftDistance * 0 : leftDistance} paddingRight={1}>
                            <FlexCenter direction="v">
                                {
                                    hasDragIcon
                                    &&
                                    <div {...listeners} {...attributes} className="drag-area">
                                        <IconComponent size={isOverlay ? iconSize/1.2 : iconSize} iconName={`Drag`} />
                                    </div>
                                }
                                <IconComponent size={isOverlay ? iconSize/1.2 : iconSize} iconName={`${camelCaseToWords(node.Type)}_green`} />
                            </FlexCenter>
                        </SpacingCustom>
                        <div className="dashboard-item__title--text">
                            <FlexCenter direction={`${isOverlay ? 'h' : 'v'}`} position={`${isOverlay ? 'start' : 'center'}`} gap={isOverlay ? 0 : .5}>
                                <Title text={substringWords(node.Name, 11)} size={titleSize} />
                                <TextCustom color="grey-dark">{`(${camelCaseToWords(node.Type)})`}</TextCustom>
                            </FlexCenter>
                            { "path" in node && <TextCustom weight={500} color="grey-dark">{formatPath(node.path ?? "")}</TextCustom> }
                        </div>
                    </div>
                    {
                        !isOverlay
                        &&
                        <DashboardBar node={node} display={display}/>
                    }
                </section>
            </Spacing>
        </CleanButton>

    return (
        <div
            key={idx}
            ref={setNodeRef} 
            style={style}
            >
            <article style={{width:isOverlay ? '160px' : '100%'}}>
                {
                    showBg
                    ?
                    <PanelLayout stretch={!isOverlay} animareOutline = {outline} radius="m" hasShadow={false} color="grey-superLight" colorIntensity={.75} borderIntensity={.13}>
                        {articleContent}
                    </PanelLayout>
                    :
                    articleContent
                }
            </article>
        </div>
    )
}   